<div
  class="z-sheet-container z-fx-col"
  [style.background-color]="(ss.colors | async).mood"
  [class.hiding]="hidden | async"
>
  <ng-content></ng-content>
</div>
